/* eslint-disable array-callback-return */
import {Card, CardContent, CircularProgress, Grid, makeStyles} from '@material-ui/core';
import LocalizedText, {localize} from 'commons/LocalizedText/LocalizedText';
/* eslint-disable no-restricted-globals */
import React, {useEffect, useState} from 'react';
import Chart from 'react-google-charts';
import {useHistory, useParams} from 'react-router-dom';
import {GENERATE_ROUTE, ROUTES} from 'utils/constants/routes';
import {COLUMN_CHART_AXIS_LABEL, DETAILED_STATISTICS} from 'utils/constants/stats';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 160,
    margin: 10,
    boxShadow: theme.palette.shadow.card
  },
  cardTitle: {
    fontSize: '110%'
  },
  statDisplay: {
    margin : 10,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    borderRadius: '10%',
    minWidth: 40,
    textAlign: 'center'
  }
}));

const PIE_CHART_OPTION = {
  chartArea: {
    height: '80%',
    width: '70%'
  },
  colors: ['rgb(66, 133, 244)', 'rgb(109, 44, 136)', 'rgb(241, 78, 50)', 'rgb(171, 171, 171)'],
  legend: {
    alignment: 'center',
    position: 'top',
    textStyle: {
      fontSize: 12
    }
  },
  sliceVisibilityThreshold: 0,
  tooltip: {}
};

const COLUMN_CHART_LATE_TESTS_OPTION = {
  colors: ['rgb(109, 44, 136)', 'rgb(241, 78, 50)'],
  legend: {
    alignment: 'center',
    position: 'top',
    textStyle: {
      fontSize: 12
    }
  },
  isStacked: true
}

const COLUMN_CHART_BILLING_IS_TO_BE_MADE_OPTION = {
  colors: ['rgb(109, 44, 136)', 'rgb(171, 171, 171)'],
  legend: {
    alignment: 'center',
    position: 'top',
    textStyle: {
      fontSize: 12
    }
  },
  isStacked: true
}

export const StatisticCard = ({
  title, stats, chartType = 'PieChart', isLoadingStats, totalLabel
}) => {
  const classes = useStyles();
  const [options, setOptions] = useState({});
  const [data, setData] = useState([]);
  const [statTotal, setStatTotal] = useState(0);
  const history = useHistory();
  const { laboratory } = useParams();

  useEffect(() => {
    switch (chartType) {
    case 'ColumnChart':
      if(title === 'lateTests'){
        setOptions(COLUMN_CHART_LATE_TESTS_OPTION)
      }else{
        setOptions(COLUMN_CHART_BILLING_IS_TO_BE_MADE_OPTION)
      }
      break;

    default:
      setOptions(PIE_CHART_OPTION)
      break;
    }
  }, [chartType, title])

  useEffect(() => {
    if(!isLoadingStats && stats.detailedStats){
      const tmpData = [];
      stats.detailedStats.forEach((stat, index) => {
        if(index !== 0){
          if(chartType === 'PieChart'){
            tmpData.push([stat.name, stat.stat]);
          }else{
            tmpData.push([stat.name, stat.stat1, stat.stat2]);
          }
        }
      });
      setStatTotal(stats.detailedStats.reduce((accumulator, stat, index) => {
        if(index !== 0){
          if(chartType === 'PieChart'){
            return accumulator + stat.stat;
          }else{
            return accumulator + stat.stat1 + stat.stat2;
          }
        }else{
          return accumulator;
        }
      }, 0));
      tmpData.unshift(stats.detailedStats[0]);
      setData(tmpData);
    }
  }, [stats, isLoadingStats, chartType])

  return (
    <Card className={classes.root}>
      <Grid alignItems='center' container justifyContent='center' spacing={2}>
        <Grid item>
          <LocalizedText className={classes.cardTitle}>
            {title}
          </LocalizedText>
        </Grid>
        {!isLoadingStats && <Grid className={classes.statDisplay} item>
          {chartType === 'PieChart' ?
            stats.statNumber
            :
            statTotal
          }
        </Grid>}
      </Grid>
      <CardContent>
        <Grid alignItems='center' container direction="column" justifyContent='center'>
          {!isLoadingStats ?
            <>
              <Grid item>
                {statTotal > 0 ?
                  <Chart
                    chartEvents={[
                      {
                        eventName: 'select',
                        callback: ({ chartWrapper }) => {
                          const chart = chartWrapper.getChart();
                          const selection = chart.getSelection()[0];

                          if (selection) {
                            const { row, column } = selection;
                            const selectedStatProps = {};
                            if(chartType === 'PieChart'){
                              selectedStatProps.selectedStat = DETAILED_STATISTICS[title].stats[row];
                            }else{
                              selectedStatProps.selectedStat = DETAILED_STATISTICS[title].stats[column-1];
                              selectedStatProps.selectedStatBoundary = COLUMN_CHART_AXIS_LABEL[row];
                            }
                            history.push(
                              `${GENERATE_ROUTE(ROUTES.TESTS, { laboratory })}${location.search}&isFromHome=true`,
                              { ...selectedStatProps }
                            );
                          }
                        }
                      }
                    ]}
                    chartType={chartType}
                    data={[...data]}
                    loader={<CircularProgress />}
                    options={options}
                  />
                  :
                  <LocalizedText>noData</LocalizedText>}
              </Grid>
              {(chartType === 'PieChart' && statTotal > 0) && (
                <Grid item>
                  Total: {statTotal} {localize(totalLabel)}
                </Grid>
              )}
            </>
            :
            <CircularProgress size={80} style={{marginTop: '40px'}}/>
          }
        </Grid>
      </CardContent>
    </Card>
  )
};